import MainService from '../main.service';
import configs from '../../../configs';

export default class UserService {
  mainService = null;
  path = null;
  objSocket = null;
  bolConect = false;

  constructor() {
    this.mainService = new MainService();
    this.path = '/v1/admin';
  }

  loginGetSSO = () => {
    return this.mainService.get(
      configs.auth_api_url + '/v1/sso/saml/login',
      false,
    );
  };

  checkAssert = id => {
    return this.mainService.post(
      configs.auth_api_url + '/v1/sso/saml/check-assert',
      { str_req_to: id },
      false,
    );
  };

  loginKeycloakAuth = data => {
    return this.mainService.post(
      configs.auth_api_url + '/oauth-logons-backup',
      data,
      { skipSessionCheck: true },
    );
  };
  loginMicrosoftAuth = data => {
    return this.mainService.post(
      configs.auth_api_url + '/microsoft-oauth-logons',
      data,
    );
  };
  logoutNew = () => {
    return this.mainService.post(
      configs.auth_api_url + '/logout-new',
      undefined,
      { skipSessionCheck: true },
    );
  };
}

